// extracted by mini-css-extract-plugin
export default {"container":"_404_container__IM4go","content":"_404_content__8kC36","logoContainer":"_404_logoContainer__5IhwJ","logoIcon":"_404_logoIcon__fUk7e","notFound":"_404_notFound__kFZY5"};